var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(-462 -459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 33,
    height: 33,
    rx: 12,
    transform: "translate(462 459)",
    fill: "#f44b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-trash-can-thin",
    d: "M5.841,1.815H9.472V.756A.151.151,0,0,0,9.32.605H5.992a.151.151,0,0,0-.151.151ZM12.5,2.42H2.815V13.313a.605.605,0,0,0,.605.605h8.472a.605.605,0,0,0,.605-.605ZM6.446,4.538a.3.3,0,0,0-.605,0V11.8a.3.3,0,0,0,.605,0Zm3.026,0a.3.3,0,1,0-.605,0V11.8a.3.3,0,0,0,.605,0Zm4.841-2.723V2.42H13.1V13.313a1.21,1.21,0,0,1-1.21,1.21H3.42a1.21,1.21,0,0,1-1.21-1.21V2.42H1V1.815H5.236V.605A.605.605,0,0,1,5.841,0H9.472a.605.605,0,0,1,.605.605v1.21Z",
    transform: "translate(470.5 468.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.440549d8a28297695087f9c93168365d.svg";
export { ForwardRef as ReactComponent };